import React, { useEffect } from "react";
import axios from "axios";
import { useCookies } from "react-cookie";
import "./App.css";
import Router from "./Router";
import { installAuthInterceptor } from "./utils/api";
import ChatSocketProvider from "./context/ChatSocket/ChatSocketProvider";
import PendingSalesSyncManager from "./Components/PendingSalesSyncManager";

function App() {
  const [cookies, , removeCookie] = useCookies(["auth"]);

  useEffect(() => {
    // A full page reload wipes axios' in-memory default header — reapply it from
    // the (still-valid) auth cookie so the user isn't forced to log in again.
    if (cookies.auth?.accessToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${cookies.auth.accessToken}`;
    }

    // installAuthInterceptor also wires the same refresh-on-401 handling into
    // authenticatedFetch (see utils/api.ts) — one registration covers both
    // axios-based pages and fetch-based pages.
    installAuthInterceptor(() => {
      removeCookie('auth', { path: '/' });
      delete axios.defaults.headers.common['Authorization'];
      // replace, not a plain href assignment: this fires from whatever
      // RoleGuard-protected page the session expired on, and a plain
      // assignment pushes '/auth' on top of it in history — same stale-
      // guarded-entry bug fixed via navigate(..., { replace: true }) in
      // Sidebar's logout and AuthenticationPage's post-login redirect.
      // Without this, logging back in and pressing Back once lands back on
      // the expired guarded page, immediately re-triggering this same
      // 401 -> redirect loop.
      window.location.replace('/auth');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <PendingSalesSyncManager />
      <ChatSocketProvider>
        <Router />
      </ChatSocketProvider>
    </div>
  );
}

export default App;
